// Re-export the main Supabase client to avoid duplicate GoTrueClient instances.
// Previously this file created a separate client for public pages, but that caused
// "Multiple GoTrueClient instances" warnings. The main client already supports
// unauthenticated reads via RLS policies.
import { supabase } from "@/integrations/supabase/client";

export const publicSupabase = supabase;
